// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../../../graphql/api/index';

import { gql } from 'graphql-tag';
export const QuestionnaireQuestionTextFragmentDoc = gql`
    fragment questionnaireQuestionText on QuestionnaireQuestionText {
  __typename
  id
  title
  label
  placeholder
  required
  textarea
}
    `;